import React from 'react';
import { Button } from "@/components/ui/button";
import { Menu, Brain, LogOut, SettingsIcon } from "lucide-react";
import { useDesignSystem, cn } from '../../designSystem';

const MobileHeader = ({ setIsMobileMenuOpen, setIsSettingsOpen, username, handleLogout, isLandscape }) => {
  const { colors, typography, componentStyles } = useDesignSystem();
  
  return (
    <div className={cn(
      colors.neutral.bg, 
      colors.neutral.border, 
      "border-b",
      isLandscape && "p-0"
    )}>
      <div className={cn(
        "flex items-center justify-between",
        isLandscape ? "h-10 px-2" : "p-3"
      )}>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setIsMobileMenuOpen(true)}
          className={cn(
            componentStyles.button.base,
            componentStyles.button.ghost,
            isLandscape && "h-8 w-8"
          )}
        >
          <Menu className={isLandscape ? "h-4 w-4" : componentStyles.button.iconSizes.md} />
        </Button>

        <div className={cn(
          "flex items-center",
          isLandscape ? "space-x-1" : "space-x-3"
        )}>
          <div className={cn(
            colors.primary.gradient, 
            isLandscape ? "p-1.5 rounded-lg" : "p-2 rounded-xl"
          )}>
            <Brain className={isLandscape ? "h-3 w-3 text-white" : "h-4 w-4 text-white"} />
          </div>
          <h2 className={cn(
            typography.gradient, 
            isLandscape ? "text-base font-medium" : "text-lg font-semibold"
          )}>
            Skribo
          </h2>
        </div>

        <div className="flex items-center">
          {!isLandscape && (
            <span className={cn(typography.small, colors.neutral.textSecondary, "mr-2")}>
              {username}
            </span>
          )}
          <Button
            variant="ghost"
            size="icon"
            onClick={handleLogout}
            className={cn(
              componentStyles.button.base,
              componentStyles.button.ghost,
              "mr-2",
              isLandscape && "h-8 w-8"
            )}
            title="Logg ut"
          >
            <LogOut className={cn(
              isLandscape ? "h-3 w-3" : componentStyles.button.iconSizes.sm,
              colors.neutral.textSecondary
            )} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsSettingsOpen(true)}
            className={cn(
              componentStyles.button.base,
              componentStyles.button.ghost,
              isLandscape && "h-8 w-8"
            )}
          >
            <SettingsIcon className={isLandscape ? "h-3 w-3" : componentStyles.button.iconSizes.md} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;